import React, { Component } from 'react';

class InputFiltros extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this._validarFechaReal = this._validarFechaReal.bind(this);
    }

    //Funcion para validar que la fecha exista en el calendario
    _validarFechaReal(fecha) {
        if (fecha) {
            let fechaf = fecha.split("-");
            let d = fechaf[0];
            let m = fechaf[1];
            let a = fechaf[2];
            return m > 0 && m < 13 && a > 0 && a < 32768 && d > 0 && d <= (new Date(a, m, 0)).getDate();
        } else {
            return null;
        }
    }

    handleChange(e) {
        let instancia = this.props.instancia;
        let valor = this.props.filtroSeleccionado.valorInput;
        let result = e.key == " " && !valor ? false : true;
        let regexFechaHora = /^([0][1-9]|[1|2][0-9]|[3][0|1])[-]([0][1-9]|[1][0-2])[-]([1-2]{1})([0-9]{3} ([0-1]?[0-9]|2[0-3]):[0-5][0-9])$/ig
        let esFechaValida = false;
        let fechaValidadaError = false;

        if (!result) {
            e.preventDefault();
        }

        this.props.actions.updateInputFiltro(e.target.value, e.target.id);

        //Si la propiedad a filtrar contiene fecha y hora se valida que la fecha sea válida y se ignora la hora
        if (instancia.TipoCodigo == "DATETIME") {
            if (new RegExp(instancia.Regexp).test(e.target.value) && !e.target.value == "") {
                esFechaValida = this._validarFechaReal(e.target.value);

                if (!esFechaValida) {
                    fechaValidadaError = true;
                    this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, false, fechaValidadaError);
                }
            }

            //Validación especial para la propiedad 'FECHAHORA' para validar la hora en caso de ser ingresada.
            if (instancia.Codigo == 'FECHAHORA' && !regexFechaHora.test(e.target.value) && instancia.Regexp && !e.target.value == "" && !esFechaValida) {
                this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, true, fechaValidadaError);
            } else if (instancia.Codigo != 'FECHAHORA' && !new RegExp(instancia.Regexp).test(e.target.value) && instancia.Regexp && !e.target.value == "" && !esFechaValida) {
                this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, true, false);
            }
            else {
                esFechaValida = esFechaValida ? esFechaValida : this._validarFechaReal(e.target.value.split(" ")[0]);
    
                if (!esFechaValida && !e.target.value == "") {
                    this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, false, true);
                } else {
                    this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, false, false);
                }
            }
        } else {
            if (!new RegExp(instancia.Regexp).test(e.target.value) && instancia.Regexp && !e.target.value == "") {
                this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, true, false);
            }
            else {
                this.props.actions.validacionErrorFormatoFiltro(instancia.PropiedadId, false, false);
            }
        }
        
    }

    render() {
        const { filtroSeleccionado, instancia, error, errorFormato, errorFechaInvalida } = this.props

        return (
            <div className='VistaInstanciaParametro-Filtros-Marign-Top VistaInstanciaParametro-Filtros-Height'>
                <input
                    type='text'
                    onChange={this.handleChange}
                    id={instancia.Codigo}
                    value={filtroSeleccionado.valorInput}
                    className="form-control VistaInstanciaParametro-Filtros-Criterio-Busqueda-Label"
                />
                {error && <label className="error">Ingrese un valor</label>}
                {!errorFechaInvalida && errorFormato && <label className="error">Ingrese un valor con formato válido</label>}
                {errorFechaInvalida && <label className="error">La fecha ingresada es inválida</label>}
            </div>
        );
    }
}

export default InputFiltros;